import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchLabels = createAsyncThunk(
    "label/fetchLabels",
    async ({status, sort, prasadFilter}) => {
 const response = await axiosInstance.get("/api/label/label-address", {
            params: { status , sort, prasadFilter },
        });
        return response.data;
        
    }
);

export const generateLabelsPdf = createAsyncThunk(
    "label/generateLabelsPdf",
    async (data) => {
        const response = await axiosInstance.post("/api/label/label-pdf", { data });
        return response.data;
    }
);

const labelSlice = createSlice({
    name: "label",
    initialState: {
        labels: [],
        loading: false,
        error: null,
    },  
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLabels.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLabels.fulfilled, (state, action) => {
                state.labels = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchLabels.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(generateLabelsPdf.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generateLabelsPdf.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(generateLabelsPdf.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default labelSlice.reducer;